import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAllBySede(sedeId, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/sedes/${sedeId}`), opciones);
  },
  async findAllAsesoresBySede(sedeId) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/asesores/sedes/${sedeId}`));
  },
  async obtenerInscripcionesUPI(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/upi`), opciones);
  },
  async obtenerInscripcionesISPI(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/ispi`), opciones);
  },
  async obtenerInscripcionesPostGradosSigloXX(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/postgrados-siglo-xx`), opciones);
  },
  async obtenerInscripcionesEsamCursos(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/esam-cursos`), opciones);
  },
  async obtenerInscripcionesCyberCorp(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/cybercorp`), opciones);
  },
  async obtenerInscripcionesCCTP(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/cctp`), opciones);
  },
  async obtenerInscripcionesCK(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/ck`), opciones);
  },
  async obtenerInscripcionesPostGradosUAP(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/postgrados-uap`), opciones);
  },
  async obtenerInscripcionesCCA(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/cca`), opciones);
  },
  async exportarInscripcionesUPIAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/upi`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesISPIAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/ispi`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesPostGradosSigloXXAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/postgrados-siglo-xx`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesPostGradosUAPAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/postgrados-uap`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesCCAAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cca`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasUPIAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/upi/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasISPIAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/ispi/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasPostGradosSigloXXAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/postgrados-siglo-xx/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasPostGradosUAPAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/postgrados-uap/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasCCAAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cca/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesUPIAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/upi/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesISPIAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/ispi/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesPostGradosSigloXXAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/postgrados-siglo-xx/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesPostGradosUAPAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/postgrados-uap/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesCCAAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cca/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesEsamCursosAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/esam-cursos`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasEsamCursosAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/esam-cursos/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesEsamCursosAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/esam-cursos/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesCCTPAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cctp`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasCCTPAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cctp/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesCCTPAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cctp/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesCyberCorpAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cybercorp`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasCyberCorpAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cybercorp/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesCyberCorpAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cybercorp/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesCASAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cas`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasCASAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cas/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesCASAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/cas/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesCKAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/ck`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarInscripcionesConsolidadasCKAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/ck/consolidado`), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async exportarReporteInscripcionesCKAExcel(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones/v3/excel/ck/reporte`), {
      ...opciones,
      responseType: 'blob',
    });
  },
};
